if ("serviceWorker" in navigator) {
    const serviceWorkerVersion = '4';
    // register() también solicita al navegador comprobar si existe una versión
    // nueva cuando ya hay un worker activo.
    navigator.serviceWorker
        .register(`/serviceworker.js?v=${serviceWorkerVersion}`, { scope: '/', updateViaCache: 'none' })
        .then(function (registration) {
            return registration.update();
        })
        .catch(function (error) {
            console.warn("No se pudo registrar el service worker:", error);
        });
}
